// Mesmas regras do backend (EmbeddedController::check) que marcam o gateway com alarme
export function boardAlarms(board) {
    let info;
    try {
        info = board && board.info ? JSON.parse(board.info) : undefined;
    } catch (e) {
        info = undefined;
    }
    if (!info) return [];

    const alarms = [];

    if (info.bufferAlocation > 92) {
        alarms.push({ critical: true, text: `Memória flash (backup) com alocação elevada: ${info.bufferAlocation}% (deveria ter sido formatada)` });
    } else if (info.bufferAlocation > 90) {
        alarms.push({ critical: false, text: `Memória flash (backup) com alocação elevada: ${info.bufferAlocation}% (aguardando formatação)` });
    }

    if (info.configurationAlocation > 70) {
        alarms.push({ critical: true, text: `Memória flash (configuração) com alocação elevada: ${info.configurationAlocation}% (reporte ao suporte)` });
    }

    const temperature = parseInt(info.temperature / 1000);
    if (info.temperature > 82000) {
        alarms.push({ critical: true, text: `Temperatura muito elevada: ${temperature} ºC (para ao atingir 85 ºC)` });
    } else if (info.temperature > 75000) {
        alarms.push({ critical: false, text: `Temperatura elevada: ${temperature} ºC` });
    }

    // Alarmes do diagnóstico gerado pelo protocol (um item por instância)
    (info.diagnostic || []).forEach((diagnostic) => {
        (diagnostic.alarms || []).filter((alarm) => alarm.active).forEach((alarm) => {
            alarms.push(diagnosticAlarm(alarm));
        });
    });

    return alarms;
}

function percent(value) {
    return `${((value || 0) * 100).toFixed(1)}%`;
}

function diagnosticAlarm(alarm) {
    const detail = alarm.detail || {};
    switch (alarm.type) {
        case "RS485_NOISE":
            return {
                critical: false,
                text: `[${alarm.name}] Ruído na RS-485 (escravo ${detail.slaveId}): ${percent(detail.errorRate)} de erros, ${detail.crc} CRC e ${detail.timeout} timeout em ${detail.reads} leituras`,
            };
        case "RS485_OFFLINE":
            return {
                critical: true,
                text: `[${alarm.name}] Escravo ${detail.slaveId} da RS-485 sem resposta: ${detail.reads} leituras sem sucesso`,
            };
        case "ENERGY_NOT_INCREASING":
            return {
                critical: true,
                text: `[${alarm.name}] Medidor não incrementa energia: esperado ${(detail.expected || 0).toFixed(2)} kWh, medido ${(detail.measured || 0).toFixed(2)} kWh`,
            };
        case "ENERGY_DECREASED":
            return {
                critical: true,
                text: `[${alarm.name}] Energia do medidor diminuiu de ${detail.from} para ${detail.to} kWh`,
            };
        default:
            return { critical: false, text: `[${alarm.name}] ${alarm.type}` };
    }
}
